import { NextRouter } from "next/router";
import * as rdd from "react-device-detect";

const getScreenResolution = () => {
    return (
      window.devicePixelRatio * screen.width +
      "X" +
      window.devicePixelRatio * screen.height
    );
  }
export const getDeviceData = (router: NextRouter) => {
    const params = router.query;
    return {
        ip: "",
        isp_name: "",
        is_used_vpn: 1,
        platform_name: "WEB",
        platform_version_code: "",
        platform_version_name: rdd.browserName, // environment.VERSION_NAME,
        os_name: rdd.osName,
        os_version: rdd.osVersion,  //this.deviceInfo.os_version,
        is_rooted: 0,
        device_uuid: "",
        device_brand: "",
        device_model: rdd.deviceType, //this.deviceInfo.deviceType,
        device_language: "",
        screen_density: window.devicePixelRatio.toString(),
        screen_resolution: getScreenResolution(),
        cpu: "",
        timezone: "",
        browser_name: rdd.browserName, //this.deviceInfo.browser,
        agent: window.navigator.userAgent, // this.deviceInfo.userAgent,
        referrer: document.referrer, // !!this.document.referrer ? this.document.referrer : "",
        utm_source: params['utm_source'], //this.utm_source,
        utm_medium: params['utm_medium'], //this.utm_medium,
        utm_campaign: params['utm_campaign'], //this.utm_campaign,
        fcm_token: "",
        google_advertising_id: "",
        google_service_framework: ""        
    }
};

